import axios from 'axios';
import {
  NetworkErrorResponse,
  NetworkErrorWithDetails,
  ValidationError,
} from './types';

export const getNetworkErrorInfo = (error: any): NetworkErrorWithDetails => {
  if (axios.isAxiosError(error)) {
    console.log({ error });

    const responseData = error.response?.data;
    const statusCode = error.response?.status ?? 0;

    if (Array.isArray(responseData)) {
      const validationErrors = responseData as ValidationError[];

      return {
        message: validationErrors,
        body: JSON.stringify(responseData),
        statusCode,
      };
    }

    if (
      responseData &&
      typeof responseData === 'object' &&
      'detail' in responseData
    ) {
      const networkError = responseData as NetworkErrorResponse;
      return {
        message: networkError.detail,
        body: networkError.detail,
        statusCode,
      };
    }

    if (typeof responseData === 'string') {
      return {
        message: responseData,
        body: responseData,
        statusCode,
      };
    }

    return {
      message: error.message ?? 'Network error',
      body: JSON.stringify(responseData) ?? 'Unknown',
      statusCode,
    };
  }

  return {
    message: (error as Error).message ?? 'Unknown error',
    body: 'ClientError',
    statusCode: 0,
  };
};
